export const getExpertsYoutubeParams = (isDesktop) => {
    var videoOptions = {
        width: isDesktop ? 'auto' : '100vw',
        height: 'auto',
        playerVars: {
            autoplay: 0,
            controls: 1,
            rel: 0,
            showinfo: 0,
            mute: 1,
            loop: 1
        },
    }
    return videoOptions
}